import Vue from 'vue'
import VueAvatar from '@lossendae/vue-avatar'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas }  from '@fortawesome/free-solid-svg-icons'
import { far }  from '@fortawesome/free-regular-svg-icons'
import { fab }  from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(fas);
library.add(far);
library.add(fab);

Vue.component('vue-avatar', VueAvatar);
Vue.component('font-awesome-icon', FontAwesomeIcon);
